'use strict';

/*Using dragContainers allows the use of draggable and acceptDraggable directives in child doms. It will automaticly add a dragindicator that follows the mouse when trying to drag a draggable.
 * nesting dragContainers give double dragindicators and will trigger mouseleave events when you mouse over the parent's dragindicator. Seems to work with popups.*/

angular.module('posApp').directive('dragContainer', ($log, dragItem) => ({
  restrict: 'A',

  //Not suitable for svg elements.
  link: function ($scope, $element, $attrs) {
    const el = $element[0];
    let dragBox;
    $scope.$on('startDragging', () => {
      const offsetT = 5 - $(el).offset().top;
      const offsetL = 5 - $(el).offset().left;
      if (dragItem.html) {
        dragBox = $(dragItem.html);
        $($element).append(dragBox).trigger('create');
        $(dragBox).css({
          position: 'absolute',
          'z-index': 10,
        });
        $(dragBox).addClass(dragItem.draggedItem.objectType);
        $(dragBox).trigger('create');
        $log.log(dragBox);
      }
      $element.bind('vmousemove', (event) => {
        dragItem.setPosition(event.pageX + offsetL, event.pageY + offsetT);
        if (dragBox) {
          $(dragBox).css({
            left: event.pageX + offsetL,
            top: event.pageY + offsetT,
          });
        }
      });
      $element.bind('mouseleave', (event) => {
        //if(event.target == $element[0]) {
        $log.log('stop: left Container');
        dragItem.stop();
        //}
      });
      $element.bind('vmouseup', (event) => {
        $log.log('stop: mouseup');
        dragItem.stop();
      });
    });
    //This is done through dragItem.stop() rather than directly because the mouse events also need to be unbind when stopped through any other way.
    $scope.$on('stopDragging', () => {
      $element.unbind('vmousemove');
      $element.unbind('mouseleave');
      $element.unbind('vmouseup');
      if (dragBox) {
        $(dragBox).remove();
      }
      dragBox = null;
    });
  },
}));
